import PriceSliderBox from "@/shared/components/common/PriceSliderBox";
import UploadDocuments from "@/shared/components/common/uploadDocuments";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
import { Dispatch, SetStateAction, useEffect } from "react";
interface RequestedCreditAmountThirdTabProps{
  min_price?: string | number | undefined;
  max_price?: string | number | undefined;
  min_month?: string | number | undefined;
  max_month?: string | number | undefined;
  setValuePriceSlider?: Dispatch<SetStateAction<any>>;
  setValueMonthSlider?: Dispatch<SetStateAction<any>>;
  valuePriceSlider?: string | string | undefined;
  valueMonthSlider?: string | string | undefined;
  setUploadImageCheckbookImage?: any;
  step_price:string;
  step_month:string;
}
/**
 * RequestedCreditAmountThirdTab
 *
 * تب سوم در فرآیند بررسی اطلاعات اعتباری کاربر.
 * شامل:
 * - تعیین مبلغ اعتبار درخواستی با استفاده از PriceSliderBox.
 * - تعیین مدت زمان بازپرداخت با استفاده از PriceSliderBox.
 * - بارگذاری تصویر چک ضمانت (خام و پر نشده).
 *
 * ویژگی‌ها:
 * - دریافت مقادیر حداقل و حداکثر مبلغ و ماه برای تنظیم اسلایدرها.
 * - استفاده از useEffect برای واکنش به تغییرات مقدار اسلایدرها.
 * - مدیریت بارگذاری تصویر چک ضمانت از طریق setUploadImageCheckbookImage.
 *
 * @param {Object} props
 * @param {string | number} [props.min_price] حداقل مبلغ اعتبار
 * @param {string | number} [props.max_price] حداکثر مبلغ اعتبار
 * @param {string | number} [props.min_month] حداقل مدت زمان بازپرداخت
 * @param {string | number} [props.max_month] حداکثر مدت زمان بازپرداخت
 * @param {Dispatch<SetStateAction<any>>} [props.setValuePriceSlider] تابع برای بروزرسانی مبلغ اعتبار
 * @param {Dispatch<SetStateAction<any>>} [props.setValueMonthSlider] تابع برای بروزرسانی مدت زمان بازپرداخت
 * @param {string | number} [props.valuePriceSlider] مقدار فعلی مبلغ اعتبار
 * @param {string | number} [props.valueMonthSlider] مقدار فعلی مدت زمان بازپرداخت
 * @param {any} [props.setUploadImageCheckbookImage] تابع برای بارگذاری تصویر چک ضمانت
 *
 * @component
 * @returns JSX.Element
 */

const RequestedCreditAmountThirdTab = ({
  min_price,
  max_price,
  min_month,
  max_month,
  setUploadImageCheckbookImage,
  setValuePriceSlider,
  setValueMonthSlider,
  valuePriceSlider,
  step_price,
  step_month,
  valueMonthSlider,}: RequestedCreditAmountThirdTabProps) => {

  useEffect(() => {}, [valueMonthSlider, valuePriceSlider]);
  console.log(  min_price,
      max_price,
      min_month,
      max_month,
      setUploadImageCheckbookImage,
      setValuePriceSlider,
      setValueMonthSlider,
      valuePriceSlider,
      valueMonthSlider,'  min_price,\n' +
      '  max_price,\n' +
      '  min_month,\n' +
      '  max_month,\n' +
      '  setUploadImageCheckbookImage,\n' +
      '  setValuePriceSlider,\n' +
      '  setValueMonthSlider,\n' +
      '  valuePriceSlider,\n' +
      '  valueMonthSlider')
  return (
    <>
      <StackKit sx={{width: "100%",display: "flex",flexDirection: "column",padding: "20px 25px",alignItems: "start",justifyContent: "space-between",}} gap={7}>
        <TypoGraphyKit variant="h6">
          لطفا مبلغ اعتبار درخواستی خود را تعیین نمایید.
        </TypoGraphyKit>
        <PriceSliderBox value={valuePriceSlider} setValue={setValuePriceSlider} min={min_price} max={max_price} step={Number(step_price)}/>
        <TypoGraphyKit variant="h6">
          لطفا مدت زمان بازپرداخت خود را تعیین نمایید.
        </TypoGraphyKit>

        <PriceSliderBox value={valueMonthSlider} setValue={setValueMonthSlider} min_month={min_month || 1} max_month={max_month || 12} width="80%" step={Number(step_month)}/>
        <Grid sx={{ display: "flex", flexDirection: "row-reverse", alignItems: "center", width: "100%",}} size={12}>
          <BoxKit sx={{width: "fit-content",height: "51px",display: "flex",alignItems: "center",justifyContent: "center",padding: "0 20px",borderRadius: "10px",color: "#fff",}}>
            لطفا تصویر چک ضمانت را به صورت خام ( پر نشده) به صورت واضح بارگذاری
            کنید. (لطفا تصویر را تا حد امکان با کیفیت و در یکی از فرمت های jpg ,
            png, jpeg و حجم حداکثر یک مگابایت بارگذاری نمایید.){" "}
          </BoxKit>
        </Grid>
        <Grid sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <UploadDocuments label="بارگذاری عکس چک ضمانت" defaultImage={"./Legal-advice.png"}
            onUpload={(file: any) => setUploadImageCheckbookImage(file)}
          />
        </Grid>
      </StackKit>
    </>
  );
};

export default RequestedCreditAmountThirdTab;
